/**
 * Начало заказа услуги по экологии (ecology-order): создаёт черновик заказа (услуга и площадки
 * подставляются из строки раздела или результата опроса) и открывает мастер заказа.
 *
 * Заказ из подраздела (кнопка «Заказать сдачу отчётности» и т.п., ecology-order-service-search)
 * передаёт подраздел в адрес мастера — шаг «Услуга» показывает только его услуги. Сервер подраздел
 * не хранит: это фильтр показа.
 */
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ecologyOrdersApi, type EcoOrderCreateInput, type EcoSection } from '@/lib/api'
import { getErrorMessage } from '@/lib/errors'

/** Черновик заказа + подраздел, из которого его начали (только для показа в мастере). */
export interface EcoOrderStartInput extends EcoOrderCreateInput {
  section?: EcoSection
}

export function useStartEcoOrder(): {
  start: (input: EcoOrderStartInput) => void
  starting: boolean
  error: string | null
} {
  const navigate = useNavigate()
  const [starting, setStarting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  return {
    starting,
    error,
    start: ({ section, ...input }) => {
      if (starting) return
      setStarting(true)
      setError(null)
      ecologyOrdersApi
        .create(input)
        .then((order) =>
          navigate(`/orders/${order.id}/ecology${section ? `?section=${section}` : ''}`),
        )
        .catch((err) => setError(getErrorMessage(err, 'Не удалось начать заказ')))
        .finally(() => setStarting(false))
    },
  }
}
